import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export const SubscriptionGatewayCard: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Assinatura</CardTitle>
        <CardDescription>
          Status, próxima cobrança e cancelamento.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex justify-end">
          <Button asChild variant="outline" className="w-full sm:w-auto">
            <Link to="/student/subscriptions">Ver assinatura</Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
